@if(hasImage) {
<p class="m-b-2"
   [ngClass]="titleFont">{{ title }}</p>
<div class="flex flex-middle">
    @if (base64) {
    <!-- Preview from base64 -->
    <div class="_profilePreview _profilePreviewBase64"
         [style.backgroundImage]="'url(' + base64 + ')'"></div>
    } @else {
    <!-- Existing image from server -->
    <img [dfImage]="currentImageUrl"
         [maxSize]="200"
         [width]="94"
         [height]="94"
         [ratio]="1"
         class="_profilePreview"
         alt="Profile image">
    }
    <button class="button-inline m-l-5 italic"
            (click)="onImageClick()">{{ 'Change picture' | translate }}</button>
</div>

} @else {
<p class="m-b-5"
   [ngClass]="titleFont">{{ uploadTitle }}</p>
<div (click)="onImageClick()"
     class="b-a b-col-42 bg-col-w b-radius-1 flex-column flex-middle flex-justify-center p-a">
    <div style="padding: 10px;"
         class="bg-col-5 b-radius-max inline-flex">
        <i class="icon-upload col-1 inline-flex"
           style="font-size: 20px;"></i>
    </div>
    <p class="p2 col-1 m-t-3">{{ 'Tap to upload your picture' | translate }}</p>

</div>
}

<input #fileInput
       type="file"
       accept=".png,.jpg,.jpeg,.heif,.heic,image/png,image/jpeg,image/heif,image/heic"
       style="display: none;"
       (change)="onFileSelected($event)">

<!-- Status result -->
<result class="w-12 center m-t-2"
        [status]="imageStatus"></result>
